export default "__VITE_ASSET__sIVw6_DH__"